(function () {
    'use strict';

// Declare app level module which depends on views, and components
    angular.module('smartpublic.config')
        .constant('BASE_URL', 'api/')
        .constant('RESOURCES_URL', 'resources')
        //don't change the next line because it's being used on gulpfile for value replace.
        .constant('CACHEBUST_VALUE', 1715275837936)
        .config(Configuration);

    Configuration.$inject = ['$logProvider', '$httpProvider'];

    function Configuration($logProvider, $httpProvider) {

        $logProvider.debugEnabled(false);

        $httpProvider.defaults.withCredentials = true;
        $httpProvider.defaults.headers.common["X-Requested-With"] = 'XMLHttpRequest';

    }

})();   